import { Injectable } from '@angular/core';
import { HttpService } from '../../utils/services/http.service';
import { Observable } from 'rxjs/Observable';
import { SessionStorage } from 'ngx-webstorage';
import { ErrorsService } from '../../utils/services/errors.service';

@Injectable()
export class DashboardService {
  @SessionStorage() public user;
  constructor(private httpService: HttpService,
    private errorsService: ErrorsService) { }

  /**API request to get dashboard detail */
  getDashboard(data): Observable<any> {
    return this.httpService.post(`rm/dashboard`, data)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  /**API request to get timesheet detail to dashboard*/
  getTimesheetDashboard(firstDay,lastDay): Observable<any> {
    const data = {
      'userDetails': {
        'Empno': this.user.Empno,
        'startDate':firstDay,
        'endDate':lastDay

      }
    };
    return this.httpService.post(`rm/dashboard/timesheet`, data)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  /**API request to get employee details*/
  getEmployeesDetails(): Observable<any> {
    const data = {
      'userDetails': {
        'EmailID': this.user.EmailID,
        'Empname': this.user.Empname,
        'Empno': this.user.Empno,
      }
    };
    return this.httpService.post(`employee/dashboard`, data)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  /**API request to get employee details*/
  getDashboardEmployeeList(): Observable<any> {
    const data = {
      'userDetails': {
        'Empno': this.user.Empno
      },
    };
    return this.httpService.post(`rm/dashboard`, data)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  /**API request to get employee locked status*/
  getLockedStatus(): Observable<any> {
    return this.httpService.get(`employee/lock/status`)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  /**function to get timesheet entry details */
  getCalendarPendingTimesheets(data): Observable<any> {
    return this.httpService.get(`pending-timesheets?month=${data.month}&year=${data.year}`)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  /**function to handle error requested*/
  handleError(error: any) {
    this.errorsService.handleError(error);
    return Observable.throw(error.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/rm/dashboard/dashboard.service.ts